import { computed } from 'vue';
import store from 'dashboard/store';
import { BUZZER_BRIDGE_SIP_EVENTS } from 'dashboard/services/BuzzerBridgeSipClient';
import sipClient from 'dashboard/services/buzzerBridgeSipClientInstance';
import {
  SET_CALL_STATUS,
  SET_REGISTRATION_STATUS,
  SET_REMOTE_AUDIO_BLOCKED,
} from 'dashboard/store/modules/buzzerBridgeSip';

const callStatusSubscribers = new Set();

sipClient.addEventListener(
  BUZZER_BRIDGE_SIP_EVENTS.REGISTRATION_STATUS_CHANGED,
  event => {
    store.commit(`buzzerBridgeSip/${SET_REGISTRATION_STATUS}`, event.detail);
  }
);

sipClient.addEventListener(
  BUZZER_BRIDGE_SIP_EVENTS.CALL_STATUS_CHANGED,
  event => {
    store.commit(`buzzerBridgeSip/${SET_CALL_STATUS}`, event.detail);
    callStatusSubscribers.forEach(subscriber => subscriber(event.detail));
  }
);

sipClient.addEventListener(
  BUZZER_BRIDGE_SIP_EVENTS.REMOTE_AUDIO_BLOCKED,
  () => {
    store.commit(`buzzerBridgeSip/${SET_REMOTE_AUDIO_BLOCKED}`, true);
  }
);

sipClient.addEventListener(BUZZER_BRIDGE_SIP_EVENTS.CALL_CONNECTED, () => {
  store.commit(`buzzerBridgeSip/${SET_REMOTE_AUDIO_BLOCKED}`, false);
});

// Store consumers can subscribe without entering a Vue component lifecycle.
export const subscribeToBuzzerBridgeCallStatus = subscriber => {
  callStatusSubscribers.add(subscriber);
  return () => callStatusSubscribers.delete(subscriber);
};

export const buzzerBridgeSipClient = sipClient;

export function useBuzzerBridgeSip() {
  const bridgeState = store.state.buzzerBridgeSip;

  return {
    registrationStatus: computed(() => bridgeState.registrationStatus),
    callStatus: computed(() => bridgeState.callStatus),
    callDirection: computed(() => bridgeState.callDirection),
    disconnectReason: computed(() => bridgeState.disconnectReason),
    registrationError: computed(() => bridgeState.registrationError),
    remoteAudioBlocked: computed(() => bridgeState.remoteAudioBlocked),
    register: credentials => sipClient.register(credentials),
    unregister: () => sipClient.unregister(),
    dial: (destination, callContext) =>
      sipClient.dial(destination, callContext),
    acceptIncomingCall: () => sipClient.acceptIncomingCall(),
    rejectIncomingCall: () => sipClient.rejectIncomingCall(),
    endCall: () => sipClient.endCall(),
    mute: () => sipClient.setMuted(true),
    unmute: () => sipClient.setMuted(false),
    retryRemoteAudio: () => sipClient.retryRemoteAudio(),
  };
}
